<template>
	<div id="app">
		<router-view></router-view>
	</div>
</template>

<script>
	export default {
		name: 'App',
	};
</script>

<style>
	/* 全局样式 */
	* {
		padding: 0;
		margin: 0;

	}

	@font-face {
		font-family: 'DIN';
		src: url('./assets/fonts/din.eot?#iefix&v=3.2.1') format('embedded-opentype'), url('./assets/fonts/din.woff?v=3.2.1') format('woff'), url('./assets/fonts/din.ttf?v=3.2.1') format('truetype'), url('./assets/fonts/din.svg?v=3.2.1') format('svg');
		font-weight: normal;
		font-style: normal;
	}

	@font-face {
		font-family: 'AlibabaSans';
		src: url('./assets/fonts/AlibabaSans-Bold.eot?#iefix&v=3.2.1') format('embedded-opentype'), url('./assets/fonts/AlibabaSans-Bold.woff?v=3.2.1') format('woff'), url('./assets/fonts/AlibabaSans-Bold.ttf?v=3.2.1') format('truetype'), url('./assets/fonts/AlibabaSans-Bold.svg?v=3.2.1') format('svg');
		font-weight: normal;
		font-style: normal;
	}

	@font-face {
		font-family: 'PingFang Bold';
		src: url('./assets/fonts/PingFang-Bold.eot?#iefix&v=3.2.1') format('embedded-opentype'), url('./assets/fonts/PingFang-Bold.woff?v=3.2.1') format('woff'), url('./assets/fonts/PingFang-Bold.ttf?v=3.2.1') format('truetype'), url('./assets/fonts/PingFang-Bold.svg?v=3.2.1') format('svg');
		font-weight: normal;
		font-style: normal;
	}

	@font-face {
		font-family: 'PingFang Medium';
		src: url('./assets/fonts/PingFang-Medium.eot?#iefix&v=3.2.1') format('embedded-opentype'), url('./assets/fonts/PingFang-Medium.woff?v=3.2.1') format('woff'), url('./assets/fonts/PingFang-Medium.ttf?v=3.2.1') format('truetype'), url('./assets/fonts/PingFang-Medium.svg?v=3.2.1') format('svg');
		font-weight: normal;
		font-style: normal;
	}




	.my-label {
		text-align: center !important;
		background-color: #F3F6F8 !important;
		font-size: 14px !important;
		color: #11192D !important;
	}

	.my-content {
		font-size: 14px !important;
		color: #11192D !important;
	}

	/* @font-face {
		font-family: 'DIN';
		src: url('./assets/font/DIN.eot?#iefix&v=3.2.1') format('embedded-opentype'), url('./assets/font/DIN.woff?v=3.2.1') format('woff'), url('./assets/font/DIN.ttf?v=3.2.1') format('truetype'), url('./assets/font/DIN.svg?v=3.2.1') format('svg');
		font-weight: normal;
		font-style: normal;
	}

	@font-face {
		font-family: 'PingFang';
		src: url('./assets/font/pingfang.eot?#iefix&v=3.2.1') format('embedded-opentype'), url('./assets/font/pingfang.woff?v=3.2.1') format('woff'), url('./assets/font/pingfang.ttf?v=3.2.1') format('truetype');
		font-weight: normal;
		font-style: normal;
	} */

	.num-din {
		font-family: 'DIN';
		font-weight: 600;
	}

	.shtime .el-input__inner {
		border: 0 !important;
		padding-right: 0 !important;
		/* text-align: right !important; */
	}

	.mt20 {
		margin-top: 20px !important;
	}

	:root {
		--el-color-primary: #FF6A00;
		--el-color-primary-light-1: #FFBE86;
		/* 可选：浅色变体 */
		--el-color-primary-light-2: #FF6A00;
		--el-color-primary-light-3: #FF6A00;
		--el-color-primary-darken-1: #FF6A00;
	}

	.el-checkbox__input.is-checked .el-checkbox__inner,
	.el-checkbox__input.is-indeterminate .el-checkbox__inner {
		background-color: #FF6A00 !important;
		border-color: #FF6A00 !important;

	}

	.search .el-input__inner {
		border-radius: 20px !important;
	}

	.el-button--primary {
		background-color: #FF6A00 !important;
		border-color: #FF6A00 !important;
	}

	.el-checkbox__input.is-checked+.el-checkbox__label {
		color: #FF6A00 !important;
	}

	#good-body {
		text-align: left;
		padding: 20px 0;


	}

	#good-body p {
		margin: 0;
		padding: 0;
	}

	#good-body p img {
		max-width: 100%;
		display: inline-block;
		vertical-align: middle;
	}

	#good-body img {
		max-width: 100%;
		display: inline-block;
		vertical-align: middle;
	}

	#app {
		font-family: 'PingFang Medium';
		background-color: #f5f5f5;
		min-height: 100vh;
		width: 100%;
		overflow: hidden;
		font-weight: 500;

	}

	.cards-uploader .el-upload {
		border: none;
		cursor: pointer;
		position: relative;
		overflow: hidden;
		width: 164px;
		height: 100px;
		display: inline-flex !important;
		align-items: center;
		justify-content: center;
		text-align: center;
		border: 1px solid #eee;
		margin-right: 30px;
		border-radius: 3px;
	}

	.cards-uploader .el-upload .bg {
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		z-index: 91;
		width: 100%;
		height: 100%;
	}

	.cards-uploader .el-upload .bg2 {
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		z-index: 99;
		width: 100%;
		height: 100%;
	}

	.cards-uploader .el-upload .add {
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		z-index: 91;
	}

	.cards-uploader .el-upload .add img {
		width: 20px;
		height: 20px;
	}

	.cards-uploader .el-upload .add p {
		height: 20px;
		line-height: 20px;
		font-size: 12px;
		color: #A9A9A9;
		text-align: center;
		margin-top: 10px;
	}

	.auth-upload .avatar-uploader .el-upload {
		border: 1px dashed #A9A9A9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
		width: 60px;
		height: 60px;
		display: inline-flex !important;
		align-items: center;
		justify-content: center;
		text-align: center;
	}

	.auth-upload .avatar-uploader .el-upload .avatar2 {
		width: 100%;
		height: 100%;
	}

	.el-radio__input.is-checked+.el-radio__label {
		color: #FF6A00 !important;
	}

	.el-radio__input.is-checked .el-radio__inner {
		border-color: #FF6A00 !important;
		background: #FF6A00 !important;
	}

	.avatar-uploader .el-upload {

		/* border: 1px dashed #EBEBEB; */
		/* border-radius: 2px; */
		cursor: pointer;
		position: relative;
		overflow: hidden;
		display: block !important;

	}

	.avatar-uploader .el-upload:hover {
		border-color: #FF6A00;
	}

	.hwk-upload .avatar-uploader .el-upload {
		border: 1px dashed #A9A9A9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
		width: 60px;
		height: 60px;
		display: inline-flex !important;
		align-items: center;
		justify-content: center;
		text-align: center;
	}

	.hwk-upload .el-upload-list--picture-card .el-upload-list__item {
		width: 60px;
		height: 60px;
		margin: 0 8px 8px 0;
	}

	.hwk-upload .avatar-uploader .el-upload:hover {
		border-color: #FF6A00;
	}

	.hwk-upload .avatar-uploader .el-upload .add {

		width: 30px;
		height: 30px;

	}

	/* 自定义分页器整体颜色 */
	.el-pagination {
		--el-pagination-bg-color: #fff;
		/* 背景色 */
		--el-pagination-button-bg: #f1f1f1;
		/* 按钮背景色 */
		--el-pagination-text-color: #333;
		/* 文字颜色 */
		--el-pagination-hover-tint-percent: 20%;
		/* hover 颜色深浅程度（百分比） */
	}

	/* 如果不生效，可以直接写CSS覆盖 */
	.el-pagination .btn-prev,
	.el-pagination .btn-next,
	.el-pagination .el-pager li {
		background-color: #f1f1f1;
		color: #333;
		border-color: #ddd;
	}

	.el-pagination .el-pager li.active {
		background-color: #FD6E00;
		/* 当前页码背景色 */
		color: #fff;
	}

	.el-pagination .btn-prev:hover,
	.el-pagination .btn-next:hover,
	.el-pagination .el-pager li:hover {
		color: #FD6E00;
	}

	.el-pagination.is-background .el-pager li:not(.disabled).active {
		background-color: #FD6E00 !important;
		color: #FFF;
	}

	.confirmButtonClass {
		background-color: #FF6A00 !important;
		border: 1px solid #FF6A00 !important;
	}

	.pointer {
		cursor: pointer;

	}

	.flex {
		display: flex;
		align-items: center;
	}

	.main {
		min-height: 100%;
		width: 100%;
		padding-top: 80px;
	}

	.warp {

		margin: 0 auto;
	}

	@media (max-width: 1199px) {
		.warp {
			width: 100%;
		}
	}

	@media (min-width: 1200px) and (max-width: 1439px) {
		.warp {
			width: 1200px;
		}
	}

	@media (min-width: 1440px) {
		.warp {
			width: 1200px;
		}
	}


	ul,
	li {
		list-style: none;
	}

	input,
	input:focus {
		outline: none
	}

	/* 适用于大多数现代浏览器 */
	input:-webkit-autofill,
	input:-webkit-autofill:hover,
	input:-webkit-autofill:focus,
	input:-webkit-autofill:active {
		-webkit-box-shadow: 0 0 0 30px white inset;
		/* 使用你希望的颜色替换白色 */
		box-shadow: 0 0 0 30px white inset;
		/* 同上 */
		-webkit-text-fill-color: initial;
		/* 修正文本颜色 */
	}

	/* 针对火狐浏览器，不过请注意，截至2025年，Firefox对自动填充样式的自定义支持仍然有限 */
	input:-moz-autofill,
	input:-moz-autofill:hover,
	input:-moz-autofill:focus,
	input:-moz-autofill:active {
		filter: none;
	}

	.see-pop .el-dialog__body {
		padding: 0 !important;
	}
</style>